export const warningsFilterActive = [
    {id: 1, label: 'translation:misc_alert_detail_notice', value: 'OTHER_EFFECT', icon: 'aviso'},
    {id: 2, label: 'translation:misc_alert_detail_detour', value: 'MODIFIED_SERVICE', icon: 'desvio'},
    {id: 3, label: 'translation:misc_alert_detail_cancelled_stop', value: 'anulada', icon: 'anulada'},
    {id: 4, label: 'translation:misc_alert_detail_schedule', value: 'anulada', icon: 'horarioModificado'},
    {id: 5, label: 'translation:commons_map_layers_tab_others', value: 'anulada', icon: 'others'},
];
